import { ChangeDetectionStrategy, Component } from '@angular/core';

import { useI18n } from '../i18n/services/i18n.service';
import { LoadingIndicatorComponent } from '../loading/loading-indicator.component';

@Component({
  selector: 'cdf-app-loading',
  template: `<cdf-loading-indicator>{{ i18n('profile.loading') }}</cdf-loading-indicator>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingIndicatorComponent],
})
export class AppLoadingComponent {
  protected readonly i18n = useI18n();
}
